module.exports = __webpack_public_path__ + "img/success.aa6c940f.png";